// extracted by mini-css-extract-plugin
export var logo = "_ch-2";
export var logoWrapper = "_ch-1";
export var strip = "_ch-0";